// extracted by mini-css-extract-plugin
export default {"configHeader":"CPConfigManagement_configHeader__ik5Vj"};